const list = async (callAPI: any, url: string) => {
    return await callAPI(url)
}

export default list
